import type {KeyboardViewType, Letters} from 'uikit'
import type {AlphaBetViewType} from 'entities'
import {RootState} from 'store'

export const getLetters = (state: RootState): Letters => state.letters.letters

export const getAlphaBetView = (state: RootState): AlphaBetViewType => state.letters.alphaBetView

export const getKeyboardView = (state: RootState): KeyboardViewType => state.letters.keyboardView
